import { Button } from '@components/Elements/Button'
import { PulsatingIcon } from '@components/Elements/Icon'
import { Text } from '@components/Elements/Text'
import { api } from '@lib/api'
import { useDebounce } from '@lib/hooks'
import { useI18n } from '@lib/i18n'
import { useNavigation } from '@react-navigation/native'
import { useAuthStore } from '@stores/auth'
import { useToastsStore } from '@stores/toasts'
import { Colors } from '@vetahealth/fishing-gear/colors'
import { DeviceTypeEnum } from '@vetahealth/tuna-can-api'
import React, { useEffect, useState } from 'react'
import { ButtonWrapper, IconWrapper, Wrapper } from './styles'

export function GarminFinish({ token, verifier }: { token?: string; verifier?: string | null }): React.ReactNode {
  const [user] = useAuthStore((state) => [state.user])
  const [addToast] = useToastsStore((state) => [state.addToast])
  const navigation = useNavigation()
  const [isLoading, setLoading] = useState(true)
  const [hasAccessError, setAccessError] = useState(false)
  const t = useI18n()

  const handlePress = useDebounce(() => {
    navigation.goBack()
  })

  useEffect(() => {
    if (user?.deviceTypes.some((deviceType) => deviceType === DeviceTypeEnum.GarminWatch)) {
      addToast({ message: t('settings.garmin.alreadyConnected') })
      navigation.goBack()
      return
    }

    if (token && verifier) {
      api.finishGarminOAuth({ oauthToken: token, oauthVerifier: verifier }).finally(() => {
        setLoading(false)
      })
      // refetch user to get updated device list
      return
    }

    if (!verifier) {
      setAccessError(true)
    }

    setLoading(false)
  }, [])

  return (
    <Wrapper>
      <IconWrapper>
        <PulsatingIcon isPaused={!isLoading} icon={['fad', 'watch-fitness']} color={Colors.mauve600} size={60} />
      </IconWrapper>
      {isLoading ? (
        <Text weight="medium">{t('settings.garmin.connecting')}</Text>
      ) : hasAccessError ? (
        <Text>{t('settings.garmin.authorizationError')}</Text>
      ) : (
        <>
          <Text weight="medium">{t('settings.garmin.connected')}</Text>
          <Text weight="medium">{t('settings.garmin.connectedInstructions')}</Text>
        </>
      )}
      <ButtonWrapper>
        <Button label={t('actions.gotIt')} variant="primary" onPress={handlePress} />
      </ButtonWrapper>
    </Wrapper>
  )
}
